<template
>
  <div class="survey">
    <div class="row">
      <div class="col-lg-12" v-if="!isLoading">
        <div class="widget">
          <div class="widget-body">
            <div class="row">
              <div class="col-5 br-1 position-relative">
                <h5 class="bb-1 pb-3 mb-3" style="font-size: 1rem;">{{ $t('labels.submitted-and-ok') }}</h5>

                <div
                    v-if="informationFieldWait"
                    style="
										width: 100%;
										height: 100%;
										text-align: center;
										padding-top: 30%;
										font-size: 20px;
										background-color: #fff;
										opacity: 0.6;
										z-index: 100;
									"
                    class="position-absolute"
                >
                  <i class="fas fa-circle-notch fa-spin"></i>
                </div>
                <div class="row mb-4" v-for="informationField in sortedInformationFields" :key="informationField.id">
                  <div class="col-6 pt-2">
                    {{ $to(informationField,'label') }}
                  </div>
                  <div class="col-1 text-center pt-2">
                    <input
                        type="checkbox"
                        @change="updateInformationField(localOffice, informationField, $event)"
                        class="mt-1 form-check"
                        v-model="informationField.checked"
                        v-if="$store.getters.permissions.includes('office-section-currentinformation-edit')"
                    />
                    <div v-if="!$store.getters.permissions.includes('office-section-currentinformation-edit')">
                      <i v-if="!informationField.checked" class="fas fa-times-circle text-danger"></i>
                      <i v-if="informationField.checked" class="fas fa-check-circle text-success"></i>
                    </div>
                  </div>
                  <div class="col-5">
                    <input
                        type="date"
                        class="form-control fixed-padding"
                        @blur="updateInformationField(localOffice, informationField, $event)"
                        v-if="informationField.checked && $store.getters.permissions.includes('office-section-currentinformation-edit')"
                        v-model="informationField.date"
                    />
                    <div v-if="!$store.getters.permissions.includes('office-section-currentinformation-edit')">
                      {{ informationField.date }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BojAPI from '@/api/boj';
import TextField from '@/components/ticket/localoffice/TextField';
import TextFieldOffice from '@/components/ticket/office/TextField';
import SelectField from '@/components/ticket/localoffice/SelectField';
import CheckboxField from '@/components/ticket/localoffice/CheckboxField';
import CheckboxFieldOffice from '@/components/ticket/office/CheckboxField';
import TextareaField from '@/components/ticket/localoffice/TextareaField';
import MemberList from '@/components/lists/member/MemberList';

export default {
  name: 'survey-page',
  components: {
    TextField,
    TextFieldOffice,
    TextareaField,
    SelectField,
    CheckboxField,
    CheckboxFieldOffice,
    MemberList,
  },
  props: {
    id: Number,
  },

  computed: {
    localOfficeFieldOptions: function () {
      return this.$store.getters.localOfficeOptions;
    },

    sortedInformationFields() {
      const fields = this.localOffice.information_fields;

      return fields.sort(function (a, b) {
        return a.label < b.label;
      });
    },
    parentActions() {
      const actions = this.commentOptions;
      return actions.filter((item) => item.parent === null);
    },
    childActions() {
      if (this.comment.parentAction !== null) {
        let parentAction = this.comment.parentAction.id;
        const actions = this.commentOptions;
        return actions.filter((item) => item.parent === parentAction);
      } else {
        return [];
      }
    },

    childAction() {
      return this.ticketData.comments.filter((item) => item.id === this.comment.childAction.id);
    },
  },
  data() {
    return {
      informationFieldWait: false,
      comment: {
        comment: '',
        parentAction: null,
        childAction: null,
      },
      commentOptions: [],
      isLoading: true,
      localOffice: {
        label: '',
      },
      showDetailSection: 1,
    };
  },
  beforeRouteEnter(to, from, next) {
    BojAPI.getLocalOffice(to.params.id)
        .then((response) => {
          next((vm) => vm.setData(response.data));
        })
        .catch((error) => {
        });
  },
  beforeRouteUpdate(to, from, next) {
    this.localOffice = null;
    BojAPI.getLocalOffice(to.params.id).then((response) => {
      this.setData(response.data);
      next();
    });
  },
  mounted() {
    this.getActions();
  },
  methods: {
    /**
     * Update Information Field.
     *
     * @param localoffice
     * @param field
     * @param event
     */
    updateInformationField(localoffice, field, event) {
      this.informationFieldWait = true;
      if ((field.checked && field.foreign_id === null) || field.foreign_id !== null) {
        BojAPI.updateLocalOfficeInformationField(localoffice, field, event.target.value)
            .then((response) => {
              this.informationFieldWait = false;
              this.setData(response.data);
              this.$notify({
                group: 'foo',
                text: this.$t('labels.changes-saved'),
                type: 'success',
                duration: 3000,
              });
            })
            .catch((error) => {
              this.informationFieldWait = false;
              this.$notify({
                group: 'foo',
                text: this.$t('labels.no-permission'),
                type: 'warning',
                duration: 3000,
              });
            });
      }
    },

    /**
     * Save new comment
     */
    saveNewComment() {
      if (this.comment.parentAction == null || this.comment.childAction == null) {
        this.$notify({
          group: 'foo',
          text: this.$t('labels.missing-forum-event'),
          type: 'error',
          duration: 3000,
        });
      } else {
        BojAPI.saveLocalOfficeComment(this.localOffice.id, this.comment)
            .then(() => {
              BojAPI.getLocalOffice(this.localOffice.id).then((response) => {
                this.setData(response.data);
              });
              this.$notify({
                group: 'foo',
                text: this.$t('labels.note-saved'),
                type: 'success',
                duration: 3000,
              });

              this.comment = {
                comment: '',
                parentAction: null,
                childAction: null,
              };
            })
            .catch((error) => {
              this.$notify({
                group: 'foo',
                text: this.$t('labels.no-permission-sending-ticket'),
                type: 'warning',
                duration: 3000,
              });
            });
      }
    },

    /**
     * Get available actions
     */
    getActions() {
      BojAPI.getLocalOfficeActions().then((response) => {
        this.commentOptions = response.data.data;
      });
    },

    /**
     * Update Local Office
     * @param ticket
     */
    updateLocalOffice(ticket) {
      this.$emit('updateLocalOffice', ticket);
    },
    setShowDetailSection(section) {
      this.showDetailSection = section;
    },

    setData(payload) {
      this.localOffice = payload.data;
      this.isLoading = false;
    },
  },
};
</script>
